export default [
  {id: 'm1', name: 'Menos de 100 c.c.', value: 0},
  {id: 'm2', name: 'Más de 100 c.c.', value: 1},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/arrays/displacement.js